import axios from 'axios';

const cdnApi = axios.create({
		baseURL: `//${process.env.VUE_APP_CDN_HOST}`,
	}),
	getFrontendConfig = () => cdnApi.get(`frontend/v2/${environment.region}/config.json`).then((res) => res.data),
	getGameList = () => cdnApi.get(`games/v2/${environment.region}/gamelist.json`).then((res) => res.data);

export default {
	getFrontendConfig,
	getGameList,
};
